export default {
  monthlyCostPosition: 'center',
  valueFontSize: '1.24rem',
  monthlyCostLabelFontSize: '1rem',
  labelColor: 'var(--black)',
  minimalPadding: '1rem 0',
  minimalMargin: '-1rem 1rem 0 0',
};
